module.exports = __webpack_public_path__ + "static/media/_DSC8752_16_9_AR.d89da2ed.jpg";